module.exports = __webpack_public_path__ + "static/img/help_09study_06.5e0da5f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/fdback/help_09study_06.png
// module id = 710
// module chunks = 140